import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "input"]
  static values = { url: String }

  connect() {
    this.displayTarget.addEventListener("click", () => this.#edit())
  }

  save(event) {
    if (event.type === "keydown") event.preventDefault()

    const value = this.inputTarget.value.trim()
    if (value === "") return this.cancel()

    const formatted = this.#formatCurrency(parseFloat(value))
    this.#showDisplay(formatted)
    this.#persist({ mrr_override: value })
  }

  cancel() {
    this.inputTarget.classList.add("d-none")
    this.displayTarget.classList.remove("d-none")
  }

  clear(event) {
    event.preventDefault()
    if (!window.confirm("Reset MRR to calculated value?")) return

    this.#persist({ mrr_override: "" })
  }

  #edit() {
    this.displayTarget.classList.add("d-none")
    this.inputTarget.classList.remove("d-none")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  #showDisplay(formatted) {
    this.inputTarget.classList.add("d-none")
    this.displayTarget.textContent = formatted
    this.displayTarget.classList.remove("d-none")
  }

  #formatCurrency(value) {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
  }

  // Accept turbo-stream so the server's update.turbo_stream.erb
  // re-renders the MRR cell (and rewind icon) in lockstep with the
  // override state we just wrote. Without this the icon's conditional
  // markup wouldn't appear until a hard refresh.
  #persist(params) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ""

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ team_playbook_setting: params }),
    }).then(async (response) => {
      if (response.ok) {
        const html = await response.text()
        if (html) Turbo.renderStreamMessage(html)
      } else {
        console.error(`[TeamPlaybook] Failed to update MRR: ${response.status}`)
        this.cancel()
      }
    }).catch((error) => {
      console.error("[TeamPlaybook] Failed to update MRR:", error)
      this.cancel()
    })
  }
}
